import { render } from "./ChordDisplay.vue?vue&type=template&id=438495dd"
import script from "./ChordDisplay.vue?vue&type=script&lang=js"
export * from "./ChordDisplay.vue?vue&type=script&lang=js"

import "./ChordDisplay.vue?vue&type=style&index=0&id=438495dd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__